import React, { useEffect, useRef, useState } from "react";
import Card from "../Card/Card.jsx";
import tampuuriWindowObject from "../../tampuuriWindowObject.js";
import SkeletonWrapper from "../SkeletonWrapper/SkeletonWrapper.jsx";
import useSkeleton from "../hooks/useSkeleton.jsx";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner.jsx";

const FreeApartments = (props) => {
  const { freeApartmentsInfoText, freeApartments, svgObjects } = props;

  const [freeApartmentsComponents, setFreeApartmentsComponents] = useState([]);
  const [state, setState] = useState({});
  const [count, setCount] = useState(0);
  const [showBtn, setShowBtn] = useState(true);
  const { translate } = tampuuriWindowObject();
  const firstRender = useRef(true);
  const { dummyApartmentCards } = useSkeleton();

  useEffect(() => {
    let finalReactComponents = [];
    setCount(freeApartments.length);

    setState({ loading: true });
    freeApartments.forEach(function (card, index) {
      if (index < 3) {
        finalReactComponents.push(
          <Card
            svgObjects={svgObjects}
            key={card.id}
            className="tampuuri-card--item card--item--apartment"
            card={card}
          />,
        );
      }
    });
    setFreeApartmentsComponents(finalReactComponents);
    setState({ loading: false });
  }, [freeApartments]);

  useEffect(() => {
    if (firstRender.current) {
      //This and the dependecyArray will prevent other re-renders from triggering dom queries
      firstRender.current = false;
      return;
    }

    //If show more apartments button has been clicked this will trigger
    //There must be at least 4 free apartments
    //Select all free-apartment cards
    const apartmentCards = document.querySelectorAll(
      ".all-free-apartments .tampuuri-card--item",
    );
    //If the fourth card exists focus to that card
    if (apartmentCards[3]) {
      apartmentCards[3].querySelector("a").focus();
    }
  }, [freeApartmentsComponents]);

  const handleButtonClick = () => {
    let finalComponents = [];
    freeApartments.forEach((card) => {
      finalComponents.push(
        <Card
          svgObjects={svgObjects}
          key={card.id}
          className="tampuuri-card--item card--item--apartment"
          card={card}
        />,
      );
    });
    setShowBtn(false);
    setFreeApartmentsComponents(finalComponents);
  };

  return (
    <>
      {freeApartmentsComponents?.length > 0 && (
        <div className="all-free-apartments">
          <div className="results-container">
            <h2 id="search-results-apartments" className="type-h3">
              {translate("Vapaat asunnot")}:{" "}
              {state?.loading ? (
                <LoadingSpinner useSpinner="ClipLoader" />
              ) : (
                count
              )}
            </h2>

            {freeApartmentsInfoText && (
              <div className="col-10 info-text">
                <div
                  dangerouslySetInnerHTML={{
                    __html: freeApartmentsInfoText,
                  }}
                />
              </div>
            )}

            <div
              role="group"
              aria-labelledby="search-results-apartments"
              className="grid-container-gap"
            >
              <SkeletonWrapper
                loading={state?.loading}
                skeleton={dummyApartmentCards()}
              >
                {freeApartmentsComponents.map((component) => {
                  return component;
                })}
              </SkeletonWrapper>
            </div>

            {showBtn && freeApartments.length > 3 && (
              <div className="col-12 show_all_free_apartments">
                <button
                  onClick={handleButtonClick}
                  id="show_all_free_apartments"
                  className="button button-primary"
                >
                  {translate("Näytä lisää vapaita asuntoja")}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FreeApartments;
